// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"c8574cf4","606":"2e122328"}[chunkId] + ".chunk.js";
};